import { render, staticRenderFns } from "./CalibTable.vue?vue&type=template&id=19799225&"
import script from "./CalibTable.vue?vue&type=script&lang=js&"
export * from "./CalibTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports